import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaymentPreUsedComponent } from './payment-pre-used.component';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { PaymentSipButtonModule } from '../payment-sip-button/payment-sip-button.module';
import { PaymentSipUpiTimerModule } from '../payment-sip-upi-timer/payment-sip-upi-timer.module';
import { PaymentMethodListModule } from '../payment-method-list/payment-method-list.module';
import { ModuleLoaderModule } from '../module-loader/module-loader.module';



@NgModule({
  declarations: [
    PaymentPreUsedComponent
  ],
  exports: [
    PaymentPreUsedComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatButtonModule,
    MatRadioModule,
    PaymentSipButtonModule,
    PaymentSipUpiTimerModule,
    PaymentMethodListModule,
    ModuleLoaderModule
  ]
})
export class PaymentPreUsedModule { }
